import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core'
import { Form, Formik } from 'formik'
import { useDispatch } from 'react-redux'
import { AddVideoCategory } from 'src/redux/actions'
import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Minimum 2 letters are required')
    .required('Required'),
  title: Yup.string().min(5, 'Minimum 5 letters are required').required('Required'),
})

const AddEditVideoCategory = ({ selectedRow, refetch, toggleDrawer }) => {
  const initialValues = {
    name: selectedRow?.name || '',
    title: selectedRow?.title || '',
    sortOrder: selectedRow?.sortOrder || 1,
  }
  const dispatch = useDispatch()

  const handleCancel = () => {
    toggleDrawer(false)
  }

  const handleSubmit = async values => {
    let dataToSubmit = selectedRow?._id
      ? { ...values, _id: selectedRow._id }
      : { ...values }
    await dispatch(AddVideoCategory(dataToSubmit))
    toggleDrawer(false)
    refetch()
  }

  return (
    <>
      <Box sx={{ m: 1 }}>
        <Container>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            validateOnBlur={true} // Validate fields on blur
            validateOnChange={false} // Prevent full validation on each change
          >
            {({ errors, touched, values, handleBlur, handleChange }) => (
              <Form>
                <Grid container spacing={3}>
                  {/* Category Name */}
                  <Grid item xs={12}>
                    <TextField
                      error={Boolean(touched.name && errors.name)}
                      fullWidth
                      helperText={touched.name && errors.name}
                      label="Category Name"
                      placeholder="Category Name"
                      name="name"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.name}
                      variant="outlined"
                      required
                      size="small"
                    />
                  </Grid>

                  {/* Category Title */}
                  <Grid item xs={12}>
                    <TextField
                      error={Boolean(touched.title && errors.title)}
                      fullWidth
                      helperText={touched.title && errors.title}
                      label="Category Title"
                      placeholder="Category Title"
                      name="title"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.title}
                      variant="outlined"
                      required
                      size="small"
                    />
                  </Grid>

                  {/* Sort Order */}
                  <Grid item xs={12}>
                    <TextField
                      error={Boolean(touched.sortOrder && errors.sortOrder)}
                      fullWidth
                      helperText={touched.sortOrder && errors.sortOrder}
                      label="Sort Order"
                      placeholder="Sort Order"
                      name="sortOrder"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.sortOrder}
                      variant="outlined"
                      required
                      size="small"
                    />
                  </Grid>

                  {/* Action Buttons */}
                  <Grid item xs={12} md={6}>
                    <Button
                      color="primary"
                      onClick={handleCancel}
                      fullWidth
                      size="large"
                      type="button"
                      variant="outlined"
                    >
                      Cancel
                    </Button>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Button
                      color="primary"
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Form>

            )}
          </Formik>
        </Container>
      </Box>
    </>
  )
}

export default AddEditVideoCategory
